/**
 * Check if a specific package tag is excluded for a license
 */
export function isPackageExcluded(state) {
  return (licenseId, tag) => {
    return state.excludedTags[licenseId]?.includes(tag) || false;
  };
}

/**
 * Get all excluded tags for a specific license
 */
export function getExcludedTagsForLicense(state) {
  return (licenseId) => {
    return state.excludedTags[licenseId] || [];
  };
}

/**
 * Get all excluded packages (for management page)
 */
export function allExcludedPackages(state) {
  return state.excludedPackages;
}

/**
 * Check if store is loading
 */
export function isLoading(state) {
  return state.loading;
}
